import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrSidepanelService {
  openPanelSubject: Subject<'left' | 'right'> = new Subject<'left' | 'right'>();
  closePanelSubject: Subject<void> = new Subject<void>();
  closedPanelSubject: Subject<void> = new Subject<void>();

  constructor() {}

  openPanel(side: 'left' | 'right' = 'right') {
    this.openPanelSubject.next(side);
  }

  closePanel() {
    this.closePanelSubject.next();
    // setTimeout(() => this.closedPanel(), parseFloat(getComputedStyle($('#ea-sidepanel')[0])['transitionDuration']) * 1000)
    setTimeout(
      () => this.closedPanel(),
      parseFloat(
        getComputedStyle(document.querySelector('#ea-sidepanel'))
          .transitionDuration,
      ) * 1000,
    );
  }

  closedPanel() {
    this.closedPanelSubject.next();
  }
}
